import { render, staticRenderFns } from "./Digital-Renovation-New-Request.vue?vue&type=template&id=15596051&scoped=true&"
import script from "./Digital-Renovation-New-Request.vue?vue&type=script&lang=js&"
export * from "./Digital-Renovation-New-Request.vue?vue&type=script&lang=js&"
import style0 from "./Digital-Renovation-New-Request.vue?vue&type=style&index=0&id=15596051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15596051",
  null
  
)

export default component.exports